// extracted by mini-css-extract-plugin
export default {"wrapper":"index__wrapper__ld5mA"};